import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <aside className="w-64 bg-gray-900 border-r border-gray-800 flex flex-col">
      {/* Header */}
      <div className="p-6 flex items-center gap-3">
        <div className="p-2 bg-primary-500 rounded-lg">
          <span className="material-symbols-outlined text-white">storefront</span>
        </div>
        <h1 className="text-xl font-bold">Admin Panel</h1>
      </div>

      {/* Navegación */}
      <nav className="flex-1 px-4 py-4">
        <Link
          to="/"
          className="flex items-center gap-3 px-4 py-2 text-gray-300 rounded-md hover:bg-gray-800"
        >
          <span className="material-symbols-outlined">dashboard</span>
          <span>Vista General</span>
        </Link>
        <Link
          to="/products"
          className="flex items-center gap-3 px-4 py-2 mt-2 text-gray-300 rounded-md hover:bg-gray-800"
        >
          <span className="material-symbols-outlined">inventory_2</span>
          <span>Productos</span>
        </Link>
        <Link
          to="/orders"
          className="flex items-center gap-3 px-4 py-2 mt-2 text-gray-300 rounded-md hover:bg-gray-800"
        >
          <span className="material-symbols-outlined">shopping_cart</span>
          <span>Pedidos</span>
        </Link>
        <Link
          to="/reports"
          className="flex items-center gap-3 px-4 py-2 mt-2 text-gray-300 rounded-md hover:bg-gray-800"
        >
          <span className="material-symbols-outlined">bar_chart</span>
          <span>Reportes</span>
        </Link>
      </nav>

      {/* Usuario */}
      {/* <div className="p-4 border-t border-gray-800">
        <div className="flex items-center gap-3">
          <div
            className="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-10 h-10"
            style={{
              backgroundImage:
                'url("https://lh3.googleusercontent.com/aida-public/AB6AXuBV5bjfnNjYf6GrFefQ5doFQ6vEV3N2aoSpeH1n4PXQs9AKwi71BnptrGTdoEQqIjW9eSSiZM6Y77PX4yoy23jtJUEg3Z2zwBjKFuQC4g4Pqdsg8Rn8abZZ82O2KzyYzsCLOo7Gh4wkgUa5h1MI4jg87u-eT-R9bCm0ON38s1wGGAvtQ9tNDpm28kW7f0TJzQqA5E3GgpsRunT9IlYc3fW8QqbkYLTuTo2ZwyMStvk3hLjwGuImqB22ysF5gq95TVL2iIpgmn60hIht")',
            }}
          ></div>
          <div>
            <p className="font-semibold">Admin User</p>
            <button className="text-sm text-gray-400 hover:text-primary-400">
              Cerrar sesión
            </button>
          </div>
        </div>
      </div> */}
    </aside>
  );
};

export default Sidebar;
